import React from 'react';
import { Icon } from '../general/Icon';

interface IconButtonProps {
  icon: React.ElementType;
  onClick: () => void;
  title?: string;
  iconSize?: number | string;
  iconColor?: string;
  backgroundColor?: string;
  padding?: string;
  borderRadius?: string;
  hoverBackgroundColor?: string;
  style?: React.CSSProperties;
}

export function IconButton({
  icon,
  onClick,
  title,
  iconSize,
  iconColor,
  backgroundColor = 'white',
  padding = '4px',
  borderRadius = '8px',
  hoverBackgroundColor = '#dfdfdf',
  style
}: IconButtonProps) {
  return (
    <button
      type='button'
      onClick={onClick}
      title={title}
      style={{
        backgroundColor,
        border: 'none',
        cursor: 'pointer',
        padding,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius,
        ...style
      }}
      onMouseEnter={(event) => {
        event.currentTarget.style.backgroundColor = hoverBackgroundColor;
      }}
      onMouseLeave={(event) => {
        event.currentTarget.style.backgroundColor = backgroundColor;
      }}
    >
      <Icon icon={icon} size={iconSize} color={iconColor} />
    </button>
  );
}
